import { Component } from 'opus-angular-seed-core';
import template from './template.html';

@Component({
    bindings: {
        formModel: '='
    },
    template
})

export default class {
    constructor ($state, $scope, $rootScope, $translate, toastr, DATATABLES, ListFactory,
                 ModalService, FormService, QuestionService, QuestionResource, FormResource, FORMS_TYPE_ENUM) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.toastr = toastr;
        this.DATATABLES = DATATABLES;
        this.ModalService = ModalService;
        this.FormService = FormService;
        this.QuestionService = QuestionService;
        this.FormResource = FormResource;
        this.FORMS_TYPE_ENUM = FORMS_TYPE_ENUM;
        this.ListFactory = ListFactory;
        this.QuestionResource = QuestionResource;

        $scope.$on('updateQuestion', () => {
            this.reloadForm();
            this.list.fetch(this.defaultQuery);
        });
    }

    $onInit () {
        this.isCertificationForm = this.formModel.type === this.FORMS_TYPE_ENUM.KEYS.CERTIFICATION;
        this.canManageQuestion = this.FormService.canManageForm(this.formModel);
        this.defaultQuery = {
            formId: this.formModel.id
        };

        if (this.isCertificationForm) {
            this.defaultQuery.sort = 'sequence';
            this.defaultQuery.expand = 'activeI18n,questionI18ns,pool,category,author,questionAnswers,questionMeta,tags,' +
                'metaGroups,questionAnswersI18ns,childQuestionsActiveI18ns,childQuestions,formQuestions,sites';
            this.initQuestions();
        }
        else {
            this.initQuestionsByCategory();
        }
        this.list.fetch(this.defaultQuery);
    }

    initQuestionsByCategory () {
        this.list = this.ListFactory.createWithoutPagination(this.QuestionResource.questionsBySecondCategory.bind(this.QuestionResource));
    }

    initQuestions () {
        this.list = this.ListFactory.createWithPagination(this.QuestionResource.query.bind(this.QuestionResource));
        this.list.sort = 'sequence';
        this.list.pagination.perPage = 25;
    }

    importQuestions (formId) {
        return this.ModalService.open({
            template: '<modals-question-import form-id="vm.formId" class="wrapper" cancel="vm.$uibModalInstance.dismiss()" update="vm.update()"/>',
            controller ($uibModalInstance, $rootScope) {
                this.$uibModalInstance = $uibModalInstance;
                this.formId = formId;
                this.update = () => {
                    $rootScope.$broadcast('updateQuestion');
                    this.$uibModalInstance.close();
                };
            },
            size: 'xlarge'
        });
    }

    addQuestions () {
        const formModel = this.formModel;
        return this.ModalService.open({
            template: `
                <modals-question-add
                    form-model="vm.formModel"
                    form-type="vm.formType"
                    sites="vm.sites"
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                />
            `,
            resolve: {
                sites: (SiteResource) => {
                    return SiteResource.query({
                        formSites: true,
                        fields: 'id,name',
                        pageSize: 0
                    }).$promise;
                }
            },
            controller (sites, $uibModalInstance) {
                this.sites = sites;
                this.$uibModalInstance = $uibModalInstance;
                this.formModel = formModel;
            },
            size: 'xlarge'
        }).then(() => this.$rootScope.$broadcast('updateQuestion'));
    }

    addFromPool () {
        const formModel = this.formModel;
        return this.ModalService.open({
            template: `
                <modals-question-add-from-pool
                    class="wrapper"
                    form-model="vm.formModel"
                    cancel="vm.$uibModalInstance.dismiss()"
                    update="vm.update()"
                />`,
            controller ($uibModalInstance, $rootScope) {
                this.$uibModalInstance = $uibModalInstance;
                this.formModel = formModel;
                this.update = () => {
                    $rootScope.$broadcast('updateQuestion');
                    this.$uibModalInstance.close();
                };
            },
            size: 'xlarge'
        });
    }

    reloadForm () {
        this.FormResource.get({
            id: this.formModel.id,
            expand: 'formI18ns,category,author,tags,formQuestions,sites'
        }).$promise.then((response) => {
            this.formModel = response;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/forms/form/questions/index.js